import { Link } from "react-router";
import { LANDING_SUPPORT } from "../constants/landing.constants";

interface LegalStubPageProps {
  title: string;
}

export default function LegalStubPage({ title }: LegalStubPageProps) {
  return (
    <div className="mx-auto max-w-[720px] px-4 py-12 md:px-8 lg:px-12">
      <Link
        to="/classes"
        className="text-[14px] font-medium text-landing-button hover:underline"
      >
        ← Back to classes
      </Link>
      <h1 className="mt-6 text-[28px] font-bold text-landing-text">{title}</h1>
      <p className="mt-4 text-[15px] leading-relaxed text-landing-body">
        Full legal content for this page is coming soon. If you have questions,
        contact us at{" "}
        <a
          href={`mailto:${LANDING_SUPPORT.email}`}
          className="font-medium text-landing-button hover:underline"
        >
          {LANDING_SUPPORT.email}
        </a>{" "}
        or {LANDING_SUPPORT.phone} ({LANDING_SUPPORT.hours}).
      </p>
    </div>
  );
}
